<template>
  <div class="advertise">
    <v-parallax height=320 :src="require('../assets/images/advertise.jpeg')" cover />

    <h3 align="center" class="i-darkblue--text mt-3">Your journey to better patronage begins here!</h3>

    <br/>

    <v-row justify="center">
      <v-col class="col-lg-4 col-11 padded-1 center curved i-blue">

        <h4 class="i-powderblue--text">What do you want to advertise?</h4>

        <v-list>
          <v-list-item link to="advertise-vehicle">
            <v-list-item-action>
              <v-icon large>mdi-car</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <h3 class="pink--text">Vehicles</h3>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="advertise-property">
            <v-list-item-action>
              <v-icon large>mdi-home</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <h3 class="pink--text">Properties</h3>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="advertise-equipment">
            <v-list-item-action>
              <v-icon large>mdi-widgets</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <h3 class="pink--text">Equipment</h3>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <br/>
    <br/>
    <v-row justify="center">
      <v-col align="center">
        <router-link to="legal">Terms and conditions apply</router-link>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'advertise'
}
</script>

<style scoped>
a.v-list-item:hover {
  background: var(--lightblue) !important
}
</style>
